import { render } from "./CustomizeWidgets.vue?vue&type=template&id=62600447&scoped=true"
const script = {}

import "./CustomizeWidgets.vue?vue&type=style&index=0&id=62600447&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62600447"]])

export default __exports__